// import PropTypes from "prop-types";
// import ThemeProvider from "./ThemeContext";

// function ContextProvider({ children = null }) {
//   return <ThemeProvider>{children}</ThemeProvider>;
// }

// ContextProvider.propTypes = {
//   children: PropTypes.node.isRequired,
// };

// export default ContextProvider;

import CombinedProvider from "./Providers/CombinedProvider";
import DiagramNotificationProvider from "./Providers/DiagramNotificationContext";
import GraphNotificationProvider from "./Providers/GraphNotificationContext";
import NotificationProvider from "./Providers/NotificationContext";
import ThemeProvider from "./Providers/ThemeContext";

const AppProvider = ({ children = null }) => (
  <CombinedProvider
    components={[
      NotificationProvider,
      ThemeProvider,
      DiagramNotificationProvider,
      GraphNotificationProvider,
    ]}
  >
    {children}
  </CombinedProvider>
);

export default AppProvider;
